var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Render the material-selection step for swimming pool cover damaged panels.
 * touches: declaration external damage UX
 * invariants: available materials mirror the shared veranda-like panel choices reused by swimpool cover
 * inputs: selected panel materials
 * outputs: v-model updates for the swimpool cover declaration state
 * see: frontend/src/shared/constants/externalDamages/SwimpoolCoverConstants.ts, frontend/src/declaration/components/externalDamage/DamageDescription/SwimpoolCover.vue
 */
import { Component, VModel } from 'vue-property-decorator';
import { ExternalDamageComponent } from '@declaration/components/externalDamage/ExternalDamageComponent';
import RadioImageButton from '@declaration/components/UI/RadioImageButton.vue';
import { SWIMPOOL_COVER_PANELS_MATERIAL_CHOICES } from '@shared/constants/externalDamages/SwimpoolCoverConstants';
import { SWIMPOOL_COVER_PANELS_TITLE } from '@declaration/constants/externalDamages/SwimpoolCoverConstants';
let SwimpoolCoverPanelMaterials = class SwimpoolCoverPanelMaterials extends ExternalDamageComponent {
    constructor() {
        super(...arguments);
        this.choices = SWIMPOOL_COVER_PANELS_MATERIAL_CHOICES;
    }
    get title() {
        return this.translateExternalDamageKey(SWIMPOOL_COVER_PANELS_TITLE);
    }
};
__decorate([
    VModel({ type: Array, default: () => [] })
], SwimpoolCoverPanelMaterials.prototype, "materials", void 0);
SwimpoolCoverPanelMaterials = __decorate([
    Component({ components: { RadioImageButton } })
], SwimpoolCoverPanelMaterials);
export default SwimpoolCoverPanelMaterials;
